<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit"
                href="javascript:void(0);"
                class="small"
                @click="openFullEdit()">
          <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>
          Ver ficha completa
        </b-link>
      </b-col>

      <b-col md="6">
        <b-form-group label="Línea *" label-size="sm">
          <b-form-select v-model="form.line_id"
                         :options="options.lines"
                         size="sm"
                         :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Seleccionar —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name"
                        size="sm"
                        placeholder="Nombre de la sublínea"
                        ref="inputName"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="primary" size="sm" @click="save()" :disabled="loading || !form.name.trim() || !form.line_id">
          <b-icon icon="check" class="mr-1"></b-icon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
    },
    data() {
      return {
        form: { name: '', line_id: 0 },
        loading: false,
        options: { lines: [] },
      }
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadForEdit(val.id)
          } else {
            this.form = { name: '', line_id: 0 }
          }
        },
      },
    },
    mounted() {
      this.loadLines()
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadLines() {
        serviceAPI.obtenerLineas().then((r) => {
          this.options.lines = r.data.map((x) => ({ value: x.id, text: x.name }))
        })
      },
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerSublinea(id)
          .then((r) => {
            this.form = Object.assign({ name: '', line_id: 0 }, r.data)
            this.form.name = this.form.name || ''
            this.form.line_id = this.form.line_id || 0
          })
          .finally(() => { this.loading = false })
      },
      openFullEdit() {
        var params = {}
        params[this.viewEditParamID] = this.item.id
        var route = this.$router.resolve({ name: this.viewEdit, params: params })
        window.open(route.href, '_blank')
      },
      save() {
        if (!this.form.name.trim() || !this.form.line_id) return
        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, {
          name: this.form.name.trim(),
          line_id: this.form.line_id,
        })
        var call = isEdit
          ? serviceAPI.editarSublinea(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarSublinea(data)
        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Sublínea actualizada' : 'Sublínea creada')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar la sublínea') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
